import ModalDatosFiscalesIncompletos from 'akasia-components/cliente/ModalDatosFiscalesIncompletos';
import IconButton from 'components/common/IconButton';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Collapse, Offcanvas, Row, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins, faShoppingCart, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import ModalSeleccionarTipoRenovacion from './Modales/ModalSeleccionarTipoRenovacion';
import useCarrito from './hooks/useCarrito';
import useTipoCambio from './hooks/useTipoCambio';
import ModalConfirmarOrden from './nueva-orden/ModalConfirmarOrden';
import ModalProductos from './nueva-orden/ModalProductos';
import PanelDetalleOrden from './nueva-orden/PanelDetalleOrden';
import ProductoCarritoItem from './nueva-orden/ProductoCarritoItem';
import SeccionDatosFacturacion from './nueva-orden/SeccionDatosFacturacion';
import ModalActualizarDatosFiscalesCliente from './seccion-datos-fiscales/ModalActualizarDatosCliente';
import SelectorMoneda from './nueva-orden/SelectorMoneda';

const NuevaOrden = () => {
    //AUTENTICACION
    const { token, setToken, idUsuario, usuario, nombreCompleto } = useToken();
    const { showErrorToast } = useToast();
    const [showModalActualizarDatos, setShowModalActualizarDatos] = useState(false);

    const [formaPago, setFormaPago] = useState([]);
    const [cliente, setCliente] = useState({});
    const [distribuidores, setDistribuidores] = useState([]);
    const [datosFacturacion, setDatosFacturacion] = useState({
        vRazonSocial: null,
        vRfc: null,
        vNumRegTrib: null,
        idCatUsoCFDI: null,
        idCatRegimenFiscal: null,
        vCp: null,
        vDireccionFiscal: null,
        vEstadoDepProv: null,
        vPais: null,
        vPaisFacturacion: null,
        vEmailFacturacion: null,
        vTelefonoFacturacion: null,
        vCodigoUso: null,
        vDescripcionUsoCFDI: null,
        vCodigoRegimen: null,
        vDescripcionRegimenFiscal: null,
        idDistribuidor: 0
    });

    const [showModalProductos, setShowModalProductos] = useState(false);
    const [fechaLimitePago, setFechaLimitePago] = useState(false);
    const [confirmandoOrden, setConfirmandoOrden] = useState(false);
    const [mensajeDatoFaltante, setMensajeDatoFaltante] = useState('');
    const [seguroStateGuardar, setSeguroStateGuardar] = useState(false);
    const [stateSeguroEliminarOrdenDetalle, setstateSeguroEliminarOrdenDetalle] = useState(false);
    const [showModalDatosFiscalesIncompletos, setShowModalDatosFiscalesIncompletos] = useState(false);
    const [originalFormaPago, setOriginalFormaPago] = useState(null);
    const [showModalTipoRenovacion, setShowModalTipoRenovacion] = useState(false);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);
    const [bIsNuevaOrden, setBIsNuevaOrden] = useState(true);
    const [monedaConfirmada, setMonedaConfirmada] = useState(false);
    const [showResumenOffcanvas, setShowResumenOffcanvas] = useState(false);
    const [showDatosFacturacionMobile, setShowDatosFacturacionMobile] = useState(false);

    const navigate = useNavigate();
    const { idClienteAkasia, idOrden } = useParams();

    const [totales, setTotales] = useState({
        idOrden: 0,
        idUsuario: idUsuario,
        idClienteAkasia: idClienteAkasia,
        idCatFormaPago: "",
        vMoneda: "",
        dFechaVenta: (new Date() + ""),
        dFechaVencimiento: (new Date() + ""),
        dSubtotal: 0.00,
        dDescuento: 0.00,
        dIVA: 0.00,
        dTotal: 0.00,
        dTipoCambio: 1.0,
        bIsPagada: false,
        bIsRecompra: false,
        bIsDistribucion: null,
        bIsFacturado: false,
        vCreatedUser: usuario
    });

    // Usar el hook de carrito
    const {
        cartItems,
        setCartItems,
        agregarProductoAlCarrito,
        eliminarProducto,
        actualizarProducto,
        toggleEditarProducto
    } = useCarrito(usuario, totales, setTotales);

    // Usar el hook de tipo de cambio
    const { consultandoTC, obtenerBanxicoTC, obtenerTipoCambio } = useTipoCambio(
        totales,
        setTotales
    );

    //Obtener Lista Productos
    const obtenerListaProductos = async (idClienteAkasia_, vMoneda_ = 'MXN') => {

        const response = await fetch("/api/orden/ObtenerDatosNuevaOrden/", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ idClienteAkasia: idClienteAkasia_, vMoneda: vMoneda_ })
        }).catch((error) => {

            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles:", ObjDetalles);
                setFormaPago(ObjDetalles.table2 ?? []);
                // Solo actualizar cliente/distribuidores en la carga inicial (table3/table4 siempre vienen)
                if (ObjDetalles.table3) {
                    const clienteData = ObjDetalles.table3?.[0] ?? {};
                    setCliente(clienteData);
                    // Inicializar datosFacturacion desde los datos del cliente si aún no está cargado
                    // (evita que idCatUsoCFDI/idCatRegimenFiscal queden en null y generen 400 al guardar)
                    setDatosFacturacion(prev => {
                        if (prev.vRfc) return prev; // Ya fue inicializado (edición o modal), no sobreescribir
                        return {
                            vRazonSocial: clienteData.vRazonSocial ?? null,
                            vRfc: clienteData.vRfc ?? null,
                            vNumRegTrib: clienteData.vNumRegTrib ?? null,
                            idCatUsoCFDI: clienteData.idCatUsoCFDI ?? null,
                            idCatRegimenFiscal: clienteData.idCatRegimenFiscal ?? null,
                            vCp: clienteData.vCp ?? null,
                            vDireccionFiscal: clienteData.vDireccionFiscal ?? null,
                            vEstadoDepProv: clienteData.vEstadoDepProv ?? null,
                            vPais: clienteData.vPais ?? null,
                            vPaisFacturacion: clienteData.vPaisFacturacion ?? null,
                            vEmailFacturacion: clienteData.vEmailFacturacion ?? null,
                            vTelefonoFacturacion: clienteData.vTelefonoFacturacion ?? null,
                            vCodigoUso: clienteData.vCodigoUso ?? null,
                            vDescripcionUsoCFDI: clienteData.vDescripcionUsoCFDI ?? null,
                            vCodigoRegimen: clienteData.vCodigoRegimen ?? null,
                            vDescripcionRegimenFiscal: clienteData.vDescripcionRegimenFiscal ?? null,
                            idDistribuidor: prev.idDistribuidor ?? 0
                        };
                    });
                }
                if (ObjDetalles.table4) setDistribuidores(ObjDetalles.table4 ?? []);

            } else {

                showErrorToast(data.vMessage);
            }
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        };
    };
    //Obtener Si es Una Compra Nueva o Una Recompra
    const obtenerIsRecompra = async (idClienteAkasia_) => {

        var _idOrden = 0;

        _idOrden = idOrden == null ? 0 : idOrden;

        const response = await fetch("/api/orden/ObtenerIsRecompra/?idClienteAkasia=" + idClienteAkasia_ + "&idOrden=" + _idOrden, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {

            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();
            console.log(data);

            if (data[0].bIsRecompra === 1) {
                setTotales({ ...totales, bIsRecompra: true });
            }
            else {
                setTotales({ ...totales, bIsRecompra: false });
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Registra una orden
     */
    const RegistrarOrden = async () => {

        totales.dFechaVencimiento = new Date(totales.dFechaVencimiento).toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10);

        totales.dFechaVenta = new Date(totales.dFechaVenta).toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10);

        //se agregan los datos de facturacion al header llamado: totales
        totales.vRazonSocial = datosFacturacion.vRazonSocial;
        totales.vRfc = datosFacturacion.vRfc;
        totales.vNumRegTrib = datosFacturacion.vNumRegTrib;
        totales.idCatUsoCFDI = datosFacturacion.idCatUsoCFDI;
        totales.idCatRegimenFiscal = datosFacturacion.idCatRegimenFiscal;
        totales.vCp = datosFacturacion.vCp;
        totales.vDireccionFiscal = datosFacturacion.vDireccionFiscal;
        totales.vEstadoDepProv = datosFacturacion.vEstadoDepProv;
        totales.vPais = datosFacturacion.vPais;
        totales.vPaisFacturacion = datosFacturacion.vPaisFacturacion;
        totales.vEmailFacturacion = datosFacturacion.vEmailFacturacion;
        totales.vTelefonoFacturacion = datosFacturacion.vTelefonoFacturacion;
        totales.vCodigoUso = datosFacturacion.vCodigoUso;
        totales.vDescripcionUsoCFDI = datosFacturacion.vDescripcionUsoCFDI;
        totales.vCodigoRegimen = datosFacturacion.vCodigoRegimen;
        totales.vDescripcionRegimenFiscal = datosFacturacion.vDescripcionRegimenFiscal;
        totales.idDistribuidor = datosFacturacion.idDistribuidor;


        var objNuevaOrden = {};

        objNuevaOrden.mHeader = totales;
        objNuevaOrden.mListDetails = cartItems;

        var jsonOrden = JSON.stringify(objNuevaOrden);
        console.log("=============================Registrar Una Orden=============================");
        console.log(jsonOrden);
        console.log(objNuevaOrden);

        setConfirmandoOrden(true);

        const response = await fetch("/api/orden/GuardarOrden_Body/", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: jsonOrden + "",
        }).catch((error) => {

            showErrorToast('Hubo un problema con la peticion Fetch:' + error);

            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                if (!bIsNuevaOrden) {//validacion para asegurar que solo envie notificacion cuando realmente se este creando una nueva orden
                    var objToActionString = crearObjAction(2, "/ordenes/detalle/" + data.detalles, '', '');
                    guardarNotificacion("Nueva orden creada", "<strong>" + nombreCompleto + "</strong> creo una nueva orden <strong>#" + data.detalles + "</strong>", 0, objToActionString, 4);

                }
                setConfirmandoOrden(false);
                navigate("/ordenes/detalle/" + data.detalles);

            } else {
                setConfirmandoOrden(false);
                showErrorToast(data.vMessage);

            }

        }
        else {

            setConfirmandoOrden(false);

            showErrorToast(response.status + ' ' + response.statusText);



            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Validar campos
     * @returns
     */
    const ValidarInformacionOrden = () => {

        /**
         * Se valida que este seleccionada una forma de PAGO
         * */
        if (totales.idCatFormaPago == "") {

            showErrorToast("Para continuar debes seleccionar una forma de pago");

            return;
        }

        /**
         * Se valida que este seleccionada una moneda
         */
        if (totales.vMoneda == "") {

            showErrorToast("Para continuar debes seleccionar una Moneda");


            return;
        }

        /**
         * Valida que este seleccionada una fecha de la venta
         */
        if (totales.dFechaVenta == "") {
            showErrorToast("Para continuar debes seleccionar una fecha de la venta");


            return;
        }

        if (cartItems == null) {
            showErrorToast("Para continuar debes agregar al menos 1 producto a la orden");


            return;
        }

        if (cartItems.length == 0) {
            showErrorToast("Para continuar debes agregar al menos 1 producto a la orden");


            return;
        }

        /**
       * Se valida que este seleccionada una forma de PAGO
       * */
        if (totales.bIsDistribucion == null) {

            showErrorToast("Para continuar debes seleccionar si es una orden por distribuidor");

            return;
        }

        setConfirmandoOrden(true);
        RegistrarOrden();

    }

    /**
     * validar si se elijio por definir
     * @param {any} idCatFormaPago
     */
    const validarCreditoCliente = (idCatFormaPago) => {
        if (idCatFormaPago == 22)
            setFechaLimitePago(true)
        else
            setFechaLimitePago(false)
    }

    /**
     * Obtiene los detalles de la orden
     */
    const obtenerInfoOrden = async () => {

        const response = await fetch("/api/orden/obtenerDetallesDelaOrden/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idOrden: idOrden })
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                const data = JSON.parse(responseType.detalles);

                console.log("===================== Obtener Detalles Orden =========================");
                console.log(data);
                console.log(data.table2);
                console.log(data.table3);

                setTotales({
                    ...data.table2[0],
                    // DB devuelve estos campos como int; OrdenHeaderDto los espera como string?
                    idUsuario:       String(data.table2[0].idUsuario       ?? ''),
                    idClienteAkasia: String(data.table2[0].idClienteAkasia ?? ''),
                    idCatFormaPago:  String(data.table2[0].idCatFormaPago  ?? ''),
                });

                // Asegurar que cada item tenga la propiedad bEdit
                const itemsConBEdit = data.table3.map(item => ({
                    ...item,
                    bEdit: item.bEdit !== undefined ? item.bEdit : false
                }));
                setCartItems(itemsConBEdit);

                setOriginalFormaPago(data.table2[0].idCatFormaPago);

                /** Datos de facturación */
                setDatosFacturacion({
                    vRazonSocial: data.table2[0].vRazonSocial,
                    vRfc: data.table2[0].vRfc,
                    vNumRegTrib: data.table2[0].vNumRegTrib,
                    idCatUsoCFDI: data.table2[0].idCatUsoCFDI,
                    idCatRegimenFiscal: data.table2[0].idCatRegimenFiscal,
                    vCp: data.table2[0].vCp,
                    vDireccionFiscal: data.table2[0].vDireccionFiscal,
                    //vEstadoDepProv: data.table2[0].vEstadoDepProv,
                    vPais: data.table2[0].vPais,
                    vPaisFacturacion: data.table2[0].vPaisFacturacion,
                    vEmailFacturacion: data.table2[0].vEmailFacturacion,
                    vTelefonoFacturacion: data.table2[0].vTelefonoFacturacion,
                    vCodigoUso: data.table2[0].vCodigoUso,
                    vDescripcionUsoCFDI: data.table2[0].vDescripcionUsoCFDI,
                    vCodigoRegimen: data.table2[0].vCodigoRegimen,
                    vDescripcionRegimenFiscal: data.table2[0].vDescripcionRegimenFiscal,
                    idDistribuidor: data.table2[0].idDistribuidor
                })

                setBIsNuevaOrden(false);
                setMonedaConfirmada(true);

                console.log("===================== Obtener Detalles Orden =========================");

            } else {
                showErrorToast(responseType.vMessage);


                //console.log(response);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);


            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    }

    /**
     * Valida que todos los datos fiscales esten llenos antes de crear una orden de compra
     */
    const validarDatosFiscales = () => {
        var datosCompletos = true;

        const validations = [
            { field: 'vRfc', message: 'Es necesario capturar el RFC' },
            { field: 'vRazonSocial', message: 'Es necesario capturar la Razón Social' },
            { field: 'vCodigoRegimen', message: 'Es necesario capturar el Régimen Fiscal' },
            { field: 'vDireccionFiscal', message: 'Es necesario capturar la dirección fiscal' },
            { field: 'vCodigoUso', message: 'Es necesario capturar el uso de CFDI' },
            { field: 'vCp', message: 'Es necesario capturar el código postal' },
            { field: 'vEmailFacturacion', message: 'Es necesario capturar el correo de facturación' },
            { field: 'vPaisFacturacion', message: 'Es necesario indicar el país de facturación', condition: () => datosFacturacion.vRfc == "XEXX010101000" }
        ];

        for (const validation of validations) {
            if (!validation.condition || validation.condition()) {
                if (!datosFacturacion[validation.field] || datosFacturacion[validation.field] == "") {
                    setMensajeDatoFaltante(validation.message);
                    datosCompletos = false;
                    break; // Stop at first error
                }
            }
        }

        if (datosCompletos) {
            setSeguroStateGuardar(true);
        }
        else {
            setShowModalDatosFiscalesIncompletos(true);
        }
    }

    /**
     * Crea un objeto de acción que especifica la acción a realizar al hacer clic en una notificación,
     * ya sea abrir un modal o redireccionar a otra página.
     */
    const crearObjAction = (TypeAction, vURL, idModalType, idLead,) => {
        var objToAction = {};
        var objDetalles = {};
        var objData = {};

        objData.idLead = idLead;

        objDetalles.vUrl = vURL;
        objDetalles.idModalType = idModalType;
        objDetalles.data = objData

        objToAction.TypeAction = TypeAction;
        objToAction.detalles = objDetalles;

        var objToActionString = JSON.stringify(objToAction);
        console.log("objToAction de la Orden: ", objToActionString);
        return objToActionString;
    };

    /**
     * Guarda una notificación
     */
    const guardarNotificacion = async (vTitulo, vCuerpo, idUsuarioTarget, objToAction, idTipoNotificacion) => {

        var jDataSend = {};
        jDataSend.vTitulo = vTitulo;
        jDataSend.vCuerpo = vCuerpo;
        jDataSend.idUsuarioTarget = idUsuarioTarget;
        jDataSend.objToAction = objToAction;
        jDataSend.idTipoNotificacion = idTipoNotificacion;

        const response = await fetch("/api/leads/guardarNotificacion/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== NOTIFICACIÓN GUARDADA ====");

            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);
            console.log("objToAction: ", objToAction);
            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                console.log("detalles: ", detalles);

                var notificacionesList = detalles.table2;
                console.log("notificacionesList: ", notificacionesList);

                notificacionesList.map((objNotify) => {
                    sendPushNotificationRealTime(objNotify.vToken, objNotify.vCuerpo);
                })


            } else {

                showErrorToast(data.vMessage);

            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);


            console.log(response);
        }
    };

    /**
     * Envia una notificacion push al usuario con el token que recibe como parametro
     */
    const sendPushNotificationRealTime = async (vToken, vNotificacion) => {

        const responseTokenFCM = await fetch("/api/account/generateToken/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {

                console.log('Hubo un problema con la peticion Fetch del token:' + error);
            });

        console.log("responseTokenFCM:", responseTokenFCM);

        if (responseTokenFCM.ok) {
            const dataFCM = await responseTokenFCM.json();
            console.log("data", dataFCM);

            var tokenFCM = dataFCM.detalles;

            try {
                const response = await fetch('https://fcm.googleapis.com/v1/projects/akasia-admin-panel/messages:send', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + tokenFCM,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        message: {
                            token: vToken,
                            data: { vNotificacion: vNotificacion }
                        }
                    })
                });

                const dataNtf = await response.json();
                console.log('Notificación enviada:', dataNtf);

            } catch (error) {
                console.error('Error al enviar la notificación:', error.message);
            }
        }
    };
    ///Valida si antes era una orden de pago por definir y ahora se cambio a otro metodo de pago
    const isChangingFromPorDefinir = () => {
        return originalFormaPago == 22 && totales.idCatFormaPago != 22 && totales.idCatFormaPago != "";
    };

    // Handlers para el panel de detalle
    const handleCambiarFormaPago = (formaPagoId) => {
        setTotales({ ...totales, idCatFormaPago: formaPagoId });
        validarCreditoCliente(formaPagoId);
    };

    const handleCambiarFechaVenta = (date) => {
        setTotales({ ...totales, dFechaVenta: new Date(date) + "" });
        if (totales.vMoneda === 'USD') {
            obtenerBanxicoTC(date);
        }
    };

    const handleCambiarFechaVencimiento = (value) => {
        setTotales({ ...totales, dFechaVencimiento: value });
    };

    const handleCambiarMoneda = (moneda) => {
        console.log('[NuevaOrden] handleCambiarMoneda - moneda seleccionada:', moneda);
        setMonedaConfirmada(true);
        if (moneda === 'MXN') {
            console.log('[NuevaOrden] Moneda es MXN, set dTipoCambio = 1');
            setTotales(prev => ({ ...prev, vMoneda: moneda, dTipoCambio: 1.0000 }));
        } else {
            console.log('[NuevaOrden] Moneda NO es MXN, invocando obtenerTipoCambio:', moneda);
            obtenerTipoCambio(moneda);
        }
    };

    // Handlers para distribuidor
    const handleCambiarTipoDistribuidor = (esDistribuidor) => {
        setTotales({ ...totales, bIsDistribucion: esDistribuidor });

        if (esDistribuidor) {
            setDatosFacturacion({});
        } else {
            setDatosFacturacion({
                vRazonSocial: cliente.vRazonSocial,
                vRfc: cliente.vRfc,
                vNumRegTrib: cliente.vNumRegTrib,
                idCatUsoCFDI: cliente.idCatUsoCFDI,
                idCatRegimenFiscal: cliente.idCatRegimenFiscal,
                vCp: cliente.vCp,
                vDireccionFiscal: cliente.vDireccionFiscal,
                vEstadoDepProv: cliente.vEstadoDepProv,
                vPais: cliente.vPais,
                vPaisFacturacion: cliente.vPaisFacturacion,
                vEmailFacturacion: cliente.vEmailFacturacion,
                vTelefonoFacturacion: cliente.vTelefonoFacturacion,
                vCodigoUso: cliente.vCodigoUso,
                vDescripcionUsoCFDI: cliente.vDescripcionUsoCFDI,
                vCodigoRegimen: cliente.vCodigoRegimen,
                vDescripcionRegimenFiscal: cliente.vDescripcionRegimenFiscal,
                idDistribuidor: 0
            });
        }
    };

    const handleSeleccionarDistribuidor = (distribuidor) => {
        setDatosFacturacion({
            vRazonSocial: distribuidor.vRazonSocial,
            vRfc: distribuidor.vRfc,
            vNumRegTrib: distribuidor.vNumRegTrib,
            idCatUsoCFDI: distribuidor.idCatUsoCFDI,
            idCatRegimenFiscal: distribuidor.idCatRegimenFiscal,
            vCp: distribuidor.vCp,
            vDireccionFiscal: distribuidor.vDireccionFiscal,
            vEstadoDepProv: distribuidor.vEstadoDepProv,
            vPais: distribuidor.vPais,
            vPaisFacturacion: distribuidor.vPaisFacturacion,
            vEmailFacturacion: distribuidor.vEmailFacturacion,
            vTelefonoFacturacion: distribuidor.vTelefonoFacturacion,
            vCodigoUso: distribuidor.vCodigoUso,
            vDescripcionUsoCFDI: distribuidor.vDescripcionUsoCFDI,
            vCodigoRegimen: distribuidor.vCodigoRegimen,
            vDescripcionRegimenFiscal: distribuidor.vDescripcionRegimenFiscal,
            idDistribuidor: distribuidor.value
        });
    };

    const handleAgregarProductoConTipoRenovacion = (producto, tipoRenovacion) => {
        agregarProductoAlCarrito(producto, tipoRenovacion);
        setShowModalProductos(false);
        setShowModalTipoRenovacion(false);
        setProductoSeleccionado(null);
    };

    const handleCancelarEdicion = () => {
        navigate(`/ordenes/detalle/${idOrden}`);
    };

    const handleVolverAtras = () => {
        if (idOrden) {
            // Si estamos editando una orden, volver al detalle de la orden
            navigate(`/ordenes/detalle/${idOrden}`);
        } else {
            // Si es nueva orden, volver al detalle del cliente
            navigate(`/clientes/detalle/${idClienteAkasia}`);
        }
    };

    /**
     * Se ejecuta por primera vez
     */
    useEffect(() => {
        obtenerListaProductos(idClienteAkasia);

        if (idOrden == null)
            obtenerIsRecompra(idClienteAkasia);

        if (idOrden != null)
            obtenerInfoOrden();
    }, []);

    return (
        <>
            {/* Botón de volver atrás */}
            <div className="mb-3">
                <Button
                    variant="link"
                    className="text-decoration-none p-0 d-inline-flex align-items-center gap-2"
                    onClick={handleVolverAtras}
                >
                    <div
                        className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: 36, height: 36 }}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <span className="fw-semibold text-primary">
                        {idOrden ? 'Volver al Detalle de la Orden' : 'Volver al Cliente'}
                    </span>
                </Button>
            </div>

            <Row className="g-3">
                {/* ── COLUMNA IZQUIERDA ── */}
                <Col xl={8}>
                    {/* PASO 1 — Selección de Moneda */}
                    <Card className="mb-3">
                        <Card.Body className="p-4">
                            <div className="d-flex align-items-start gap-3 mb-3">
                                <div
                                    className="flex-shrink-0 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                                    style={{ width: 42, height: 42, fontSize: '1.15rem' }}
                                >
                                    <FontAwesomeIcon icon={faCoins} />
                                </div>
                                <div>
                                    <h5 className="mb-1">Selecci&oacute;n de Moneda</h5>
                                    <p className="text-muted fs--1 mb-0">
                                        Selecciona la moneda para habilitar la b&uacute;squeda de productos.
                                    </p>
                                </div>
                            </div>
                            <SelectorMoneda
                                monedaSeleccionada={totales.vMoneda}
                                onCambiarMoneda={handleCambiarMoneda}
                            />
                        </Card.Body>
                    </Card>

                    <Card className="mb-3">
                        <Card.Header className="bg-light">
                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                <div className="d-flex align-items-center gap-3">
                                    <div
                                        className={`flex-shrink-0 text-white rounded-circle d-flex align-items-center justify-content-center ${monedaConfirmada ? 'bg-primary' : 'bg-secondary'}`}
                                        style={{ width: 42, height: 42, fontSize: '1.15rem' }}
                                    >
                                        <FontAwesomeIcon icon={faShoppingCart} />
                                    </div>
                                    <h5 className="mb-0">Productos</h5>
                                </div>
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                    {!monedaConfirmada && (
                                        <span className="text-warning fw-semibold fs--2 text-nowrap">
                                            &#128274; Elige la moneda para continuar
                                        </span>
                                    )}
                                    <IconButton
                                        iconClassName="me-2"
                                        variant="primary"
                                        icon="plus"
                                        disabled={!monedaConfirmada}
                                        onClick={() => setShowModalProductos(true)}
                                        className="px-4"
                                    >
                                        Agregar producto
                                    </IconButton>
                                </div>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0" style={{ minHeight: '80px' }}>
                            <Table className="fs--1 mb-0" hover>
                                {cartItems && cartItems.length > 0 && (
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th className="ps-3 py-2">Producto</th>
                                            <th className="py-2 d-none d-sm-table-cell">SKU</th>
                                            <th className="py-2 text-end d-none d-md-table-cell">P. Unitario (IVA incl.)</th>
                                            <th className="py-2 text-center">Cantidad</th>
                                            <th className="py-2 text-end d-none d-sm-table-cell">Subtotal</th>
                                            <th className="py-2"></th>
                                        </tr>
                                    </thead>
                                )}
                                <tbody>
                                    {cartItems?.map((product, index) => (
                                        <ProductoCarritoItem
                                            key={index}
                                            product={product}
                                            index={index}
                                            onEliminar={() => eliminarProducto(product.index)}
                                            onToggleEditar={(indexProd, editar) => toggleEditarProducto(indexProd, editar)}
                                            onActualizar={(indexProd, cantidad, precioUnitarioIVA) =>
                                                actualizarProducto(indexProd, cantidad, precioUnitarioIVA)
                                            }
                                        />
                                    ))}
                                    {(!cartItems || cartItems.length === 0) && (
                                        <tr>
                                            <td colSpan="6" className="text-center text-muted py-5">
                                                <p className="mb-1">No hay productos en la orden.</p>
                                                {!monedaConfirmada && (
                                                    <p className="fs--2 mb-0">Selecciona una moneda para comenzar.</p>
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Card.Body>
                        <Card.Footer className="bg-light">
                            <small className="text-muted">
                                Mostrando {cartItems?.length ?? 0}{' '}
                                {cartItems?.length === 1 ? 'producto' : 'productos'}
                            </small>
                        </Card.Footer>
                    </Card>

                    {/* ── Datos de Facturación collapse (móvil) ── */}
                    <div className="d-xl-none mt-3">
                        <Button
                            variant="outline-secondary"
                            className="w-100 d-flex align-items-center justify-content-between"
                            onClick={() => setShowDatosFacturacionMobile(prev => !prev)}
                            aria-expanded={showDatosFacturacionMobile}
                        >
                            <span>&#128196; Datos de Facturaci&oacute;n</span>
                            <span>{showDatosFacturacionMobile ? '▲' : '▼'}</span>
                        </Button>
                        <Collapse in={showDatosFacturacionMobile}>
                            <div>
                                <SeccionDatosFacturacion
                                    totales={totales}
                                    cliente={cliente}
                                    distribuidores={distribuidores}
                                    datosFacturacion={datosFacturacion}
                                    onCambiarTipoDistribuidor={handleCambiarTipoDistribuidor}
                                    onSeleccionarDistribuidor={handleSeleccionarDistribuidor}
                                    onActualizarDatos={() => setShowModalActualizarDatos(true)}
                                />
                            </div>
                        </Collapse>
                    </div>

                    {/* ── Botón móvil: abrir resumen ── */}
                    <div className="d-xl-none mt-2">
                        <Button
                            variant="success"
                            className="w-100 py-3 fw-semibold"
                            onClick={() => setShowResumenOffcanvas(true)}
                        >
                            Ver Resumen y Confirmar Orden
                        </Button>
                    </div>
                </Col>

                {/* ── COLUMNA DERECHA — solo desktop ── */}
                <Col xl={4} className="d-none d-xl-block">
                    <SeccionDatosFacturacion
                        totales={totales}
                        cliente={cliente}
                        distribuidores={distribuidores}
                        datosFacturacion={datosFacturacion}
                        onCambiarTipoDistribuidor={handleCambiarTipoDistribuidor}
                        onSeleccionarDistribuidor={handleSeleccionarDistribuidor}
                        onActualizarDatos={() => setShowModalActualizarDatos(true)}
                    />

                    <Card className="mb-3">
                        <Card.Header className="bg-light">
                            <h5 className="mb-0">Resumen de Orden</h5>
                        </Card.Header>
                        <Card.Body>
                            <PanelDetalleOrden
                                totales={totales}
                                datosFacturacion={datosFacturacion}
                                formasPago={formaPago}
                                fechaLimitePago={fechaLimitePago}
                                confirmandoOrden={confirmandoOrden || consultandoTC}
                                onCambiarFormaPago={handleCambiarFormaPago}
                                onCambiarFechaVenta={handleCambiarFechaVenta}
                                onCambiarFechaVencimiento={handleCambiarFechaVencimiento}
                                onConfirmar={() => validarDatosFiscales()}
                                bIsNuevaOrden={bIsNuevaOrden}
                                onCancelar={handleCancelarEdicion}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* ── Offcanvas móvil: Resumen & Facturación ── */}
            <Offcanvas
                show={showResumenOffcanvas}
                onHide={() => setShowResumenOffcanvas(false)}
                placement="bottom"
                style={{ height: '92vh' }}
            >
                <Offcanvas.Header closeButton className="bg-light py-2">
                    <Offcanvas.Title className="fs-0 fw-semibold">Resumen de Orden</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="overflow-auto p-3">
                    <Card className="mb-3">
                        <Card.Header className="bg-light">
                            <h5 className="mb-0">Resumen de Orden</h5>
                        </Card.Header>
                        <Card.Body>
                            <PanelDetalleOrden
                                totales={totales}
                                datosFacturacion={datosFacturacion}
                                formasPago={formaPago}
                                fechaLimitePago={fechaLimitePago}
                                confirmandoOrden={confirmandoOrden || consultandoTC}
                                onCambiarFormaPago={handleCambiarFormaPago}
                                onCambiarFechaVenta={handleCambiarFechaVenta}
                                onCambiarFechaVencimiento={handleCambiarFechaVencimiento}
                                onConfirmar={() => {
                                    setShowResumenOffcanvas(false);
                                    validarDatosFiscales();
                                }}
                                bIsNuevaOrden={bIsNuevaOrden}
                                onCancelar={handleCancelarEdicion}
                            />
                        </Card.Body>
                    </Card>
                </Offcanvas.Body>
            </Offcanvas>

            <ModalProductos
                show={showModalProductos}
                onHide={() => setShowModalProductos(false)}
                token={token}
                onAgregarProducto={(producto) => {
                    agregarProductoAlCarrito(producto);
                    setShowModalProductos(false);
                }}
                moneda={totales.vMoneda}
            />

            <ModalConfirmarOrden
                show={seguroStateGuardar && !stateSeguroEliminarOrdenDetalle}
                onHide={() => setSeguroStateGuardar(false)}
                onConfirmar={ValidarInformacionOrden}
                moneda={totales.vMoneda}
                confirmando={confirmandoOrden}
            />

            <ModalConfirmarOrden
                show={stateSeguroEliminarOrdenDetalle}
                onHide={() => setstateSeguroEliminarOrdenDetalle(false)}
                onConfirmar={ValidarInformacionOrden}
                moneda={totales.vMoneda}
                confirmando={confirmandoOrden}
                esEdicion={true}
                cambioDesdeFormaPorDefinir={isChangingFromPorDefinir()}
            />

            <ModalActualizarDatosFiscalesCliente
                setShowModalActualizarDatos={setShowModalActualizarDatos}
                showModalActualizarDatos={showModalActualizarDatos}
                objDatosFiscales={cliente}
                setObjDatosFiscales={setDatosFacturacion}
                idSource={1}
            />

            <ModalDatosFiscalesIncompletos
                showModalDatosFiscalesIncompletos={showModalDatosFiscalesIncompletos}
                setShowModalDatosFiscalesIncompletos={setShowModalDatosFiscalesIncompletos}
                mensaje={mensajeDatoFaltante}
            />

            <ModalSeleccionarTipoRenovacion
                showModalTipoRenovacion={showModalTipoRenovacion}
                setShowModalTipoRenovacion={setShowModalTipoRenovacion}
                productoSeleccionado={productoSeleccionado}
                onAgregarProducto={handleAgregarProductoConTipoRenovacion}
            />

        </>
    );
};

export default NuevaOrden;
